
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const ADD_ACTIVITIESOFDAILYLIVING_RESULT = '[ACTIVITIESOFDAILYLIVING] Add';
export const REMOVE_ACTIVITIESOFDAILYLIVING_RESULT = '[ACTIVITIESOFDAILYLIVING] Remove';


export class AddActivitiesOfDailyLivingResult implements Action {
    readonly type = ADD_ACTIVITIESOFDAILYLIVING_RESULT;

    constructor(public payload: any) { }
}
// RemovePersonalDetails
export class RemoveActivitiesOfDailyLivingResult implements Action {
    readonly type = REMOVE_ACTIVITIESOFDAILYLIVING_RESULT;

    constructor(public payload: number) { }
}

export type Actions = AddActivitiesOfDailyLivingResult | RemoveActivitiesOfDailyLivingResult;
